import { Component, inject, OnInit } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { MessageService } from 'primeng/api'
import { Button } from 'primeng/button'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'

import { InputNumber } from 'primeng/inputnumber'
import { InputText } from 'primeng/inputtext'
import { ArchiveDocumentSplitPayload } from '@app/interfaces/archive-documents'

@Component({
  templateUrl: 'dialog-split.component.html',
  imports: [
    FormsModule,
    InputNumber,
    InputText,
    Button,
  ],
})

export class DialogSplitComponent implements OnInit {
  public readonly messageService = inject(MessageService)
  public readonly ref = inject(DynamicDialogRef)
  public readonly config = inject(DynamicDialogConfig)

  public loading = false

  public detail: ArchiveDocumentSplitPayload = {
    newName: 'new-document',
    splitAfterPageNumber: 1,
  }

  ngOnInit () {
    if (this.config.data?.newName) {
      this.detail.newName = this.config.data.newName
      this.detail.splitAfterPageNumber = this.config.data.splitAfterPageNumber
    }
  }

  onSubmit () {
    this.ref.close(this.detail)
  }

  onCancel () {
    this.ref.close()
  }
}
